import { Component, Input, Output, OnInit, AfterViewInit, ViewChild, EventEmitter } from '@angular/core';
import { GlobalFunction } from '../../core/global_function';
import { ActivatedRoute, Router } from '@angular/router';
import { PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'table-list',
    templateUrl: 'tablelist.component.html',
    styleUrls: ['tablelist.component.scss']
})

export class TableListComponent implements OnInit {

  private _sort_redirect_link_flag: boolean = true;

    @Output()
    prepareBeforeSort = new EventEmitter<void>();

    @Input()
    set sort_redirect_link_flag(value) { this._sort_redirect_link_flag = value; }
    get sort_redirect_link_flag() { return this._sort_redirect_link_flag; }
    private _tableClass = 'table-bordered ';
    @Input()
    set tableClass(value: string) {
      if (value === 'history-table') {
        this._tableClass = value;
      } else {
        this._tableClass += value;
      }
    }
    get tableClass() { return this._tableClass; }
    private _listData: any = [];
    private _listDataCore: any = [];
    @Input()
    set listData(value) { this._listDataCore = value; this.showData(); }
    get listData() { return this._listData; }
    private _columns: any;
    private _columns_obj: any;
    @Input()
    set columns(value) {
        var data = [];
        for (var item of value) {
            if (item.show) { data.push(item); }
        }
        this._columns = data;
        this._columns_obj = GlobalFunction.index(this._columns, 'attribute');
        this.showData();
    }
    get columns() { return this._columns; }

    private _hasCheckbox: any;
    @Input()
    set hasCheckbox(value) { this._hasCheckbox = value; }
    get hasCheckbox() { return this._hasCheckbox; }

    private _hasEditButton: any;
    @Input()
    set hasEditButton(value) { this._hasEditButton = value; }
    get hasEditButton() { return this._hasEditButton; }

    @Input() openEditAnswerDialog: (component: any, attribute: any) => void;
    @Input() parentComponent: any;

    private _hasNo: any;
    @Input()
    set hasNo(value) { this._hasNo = value; }
    get hasNo() { return this._hasNo; }

    sortColumn: any = {};

    private _params: any = {};
    @Input()
    set params(value) { this._params = value; this.showData(); }
    get params() { return this._params; }

    private _search_flag_route: boolean = true;
    @Input()
    set search_flag_route(value) { this._search_flag_route = value; }
    get search_flag_route() { return this._search_flag_route; }

    checkedAll: any = false;
    loading: boolean = true;

    _itemCountTotal: number = 0;
    @Input()
    set itemCountTotal(value: number) {
        this._itemCountTotal = value;
        this.updateMaxPage();
    }
    get itemCountTotal(): number {
        return this._itemCountTotal;
    }

    _itemCountPerPage: number = 25;
    @Input()
    set itemCountPerPage(value: number) {
        this._itemCountPerPage = value;
        this.updateMaxPage();
    }
    get itemCountPerPage(): number {
        return this._itemCountPerPage;
    }

    @Input()
    itemCountPerPageOptions: number[];

    @Input()
    currentPage: number = 0;    // 0-based

    private maxPage: number = 0;    // 0-based

    // @Input()
    //     set tableConfig(value) {
    //         if (value && 0 < Object.keys(value).length) {
    //             this.headers = [];
    //             this.numberOfRows = 0;
    //             this.model = value.model;
    //             this.hasCheckbox = value.hasCheckbox;
    //             this.hasNo = value.hasNo;
    //     }
    // }

    /** Handle checkbox */
    @Output('selectChange') selectChange: EventEmitter<any> = new EventEmitter();

    @Output('pageChange') pageChange: EventEmitter<any> = new EventEmitter();

    constructor(private route: ActivatedRoute, private router: Router) {
        this.itemCountPerPageOptions = [10, 25, 50, 100];
    }
    ngOnInit() {}

    showData() {
        if (this._columns && this._columns.length) {
            if (this._search_flag_route) {
                this._listData = this._listDataCore;
                this.sort(this.route.params['_value'] && this.route.params['_value'].order_by ? this.route.params['_value'].order_by : '', {});
            } else {
                this.searchData(this._params);
                this._listData = this.sort(this._params.order_by, this._listData);
            }
            this.setDatanew();
        }
    }

    setDatanew() {
        var list_data_columns_date = [];
        var list_data_columns_boolean = [];
        var list_data_render = [];
        for (let item of this._columns) {
            if (item) {
                if (item.render !== undefined && typeof (item['render']) == 'function') {
                    list_data_render.push(item);
                } else {
                    switch (item.data_type) {
                        case 'date': list_data_columns_date.push(item); break;
                        case 'boolean': list_data_columns_boolean.push(item); break;
                    }
                }
            }
        }
        if (list_data_columns_date.length || list_data_columns_boolean.length || list_data_render.length) {
            if(this._listData && this._listData.length) {
                for (let data of this._listData) {
                    for (var item of list_data_columns_date) {
                        data[item.attribute] = GlobalFunction.formatDateTime(data[item.attribute], 'y-m-d');
                    }
                    for (var item of list_data_columns_boolean) {
                        let map = item['map'] ? item['map'] : { true: "Yes", false: "No" };
                        data[item.attribute] = map[data[item.attribute]];
                    }
                    for (var item of list_data_render) {
                        data['show_' + item.attribute] = item['render'].call(item['render'], data);
                    }
                }
            }
        }
    }

    searchData(params) {
        var that = this;
        var data = [];
        var params_search = Object.assign({}, params);
        if (Object.keys(params_search).length) {
            for (var item of this._listDataCore) {
                var fl = true;
                for (var k in params_search) {
                    if (params_search['order_by']) continue;
                    var v = params_search[k].toLowerCase();
                    if (v.indexOf(' - ') >= 0) {
                        var a = v.split(' - ');
                        if (!(a.length == 2 && item[k] >= a[0] && item[k] <= a[1])) {
                            fl = false;
                        }
                    } else if (v.indexOf('-') >= 0 && typeof (item[k]) == 'number' && GlobalFunction['academic_years_obj'] && GlobalFunction['academic_years_obj'][v]) {
                        if (!(GlobalFunction['academic_years_obj'][v].from_time <= item[k] && item[k] <= GlobalFunction['academic_years_obj'][v].to_time)) {
                            fl = false;
                        }
                    } else {
                        if (typeof (item[k]) == 'number' || typeof (item[k]) == 'boolean') {
                            if (item[k] != v) {
                                fl = false;
                            }
                        } else if (typeof (item[k]) == 'string') {
                            if (item[k].toLowerCase().indexOf(v) == -1) {
                                fl = false;
                            }
                        } else if (item[k] != v) {
                            fl = false;
                        } else {
                            fl = false;
                        }
                    }
                }
                if (fl) {
                    data.push(item);
                }

            }
        } else {
            for (var item of this._listDataCore) {
                data.push(item);
            }
        }
        that._listData = data;
    }

    sort(order_by, data) {
        var that = this;
        let arr = [];
        if (order_by) {
            order_by = order_by.trim();
            arr = order_by.split(" ");
        } else {
            var default_sort_obj = GlobalFunction.index(this.columns, 'default_sort');
            default_sort_obj = default_sort_obj['desc'] || default_sort_obj['asc'];
            if (default_sort_obj) {
                arr = [default_sort_obj['attribute'], default_sort_obj['default_sort']];
            }
        }
        if (arr.length > 1) {
            this.sortColumn = { attribute: arr[0], sort_by: arr[1].toLowerCase() };
            let order = arr[1].toLowerCase() == 'asc' ? 1 : -1;
            if (data.length) {
                data.sort((a: any, b: any) => {

                    if(arr[0] === 'student_code' && this.studentCodeSortFunction) {
                        return this.studentCodeSortFunction(a['student_code'], b['student_code']) * order;
                    }

                    var a1 = a[that.sortColumn.attribute];
                    var a2 = b[that.sortColumn.attribute];
                    if (that._columns_obj[that.sortColumn.attribute].type) {
                        switch (that._columns_obj[that.sortColumn.attribute].type) {
                            case 'string':
                                a1 = a1 ? a1.toLowerCase() : '';
                                a2 = a2 ? a2.toLowerCase() : '';
                                break;
                            case 'timestamp':
                                a1 = ('' + a1).length > 11 ? a1 / 1000 : a1;
                                a2 = ('' + a2).length > 11 ? a2 / 1000 : a2;
                                break;
                        }
                    }
                    if (that._columns_obj[that.sortColumn.attribute].type && that._columns_obj[that.sortColumn.attribute].type == 'boolean') {
                        return -1 * (a1 > a2 ? 1 : -1) * order;
                    } else {
                        return (a1 > a2 ? 1 : -1) * order;
                    }
                });
            }
        }
        return data;
    }


    sortByColumn(column) {
        const oldSortColumn = this.sortColumn;
        const newSortColumn: any = {
            attribute: column.attribute,
            sort_by: column.attribute === oldSortColumn.attribute ? (oldSortColumn.sort_by === 'asc' ? 'desc' : 'asc') : 'asc'
        };
        this.prepareBeforeSort.emit(newSortColumn);

        if (column.attribute === 'student_code' && column.sort) {
            this.sortColumn = Object.assign({}, newSortColumn);
        
            // Perform sorting using the customSortStudentCode function
            if (this.sortColumn.sort_by === 'asc') {
            this._listData.sort((a, b) => this.studentCodeSortFunction(a[column.attribute], b[column.attribute]));
            } else {
            this._listData.sort((a, b) => this.studentCodeSortFunction(b[column.attribute], a[column.attribute]));
            }
        } else {
            let order_by = newSortColumn.attribute;
            if (newSortColumn.sort_by == 'desc') {
                order_by = order_by + ' ' + newSortColumn.sort_by;
            }
            if (this._sort_redirect_link_flag) {
                var a = this.route.snapshot['_routerState'].url.split(';');
                var link = a[0];
                var params = Object.assign({}, this._params);
                params.order_by = order_by;
                this.router.navigate([link, params]);
            } else {
                this._params['order_by'] = order_by;
                this.showData();
            }
        }

    }
    
    studentCodeSortFunction(a, b) {
        const pattern = /([A-Za-z]+)-(\d+)/; // Regular expression to extract letters and numbers with hyphen
    
        var aMatches = a ? a.match(pattern) : null;
        var bMatches = b ? b.match(pattern) : null;

        if (!aMatches || !bMatches) {
            // Handle the case where a or b is null or undefined
            // For example, you can treat null or undefined values as empty strings
            aMatches = aMatches || ['', ''];
            bMatches = bMatches || ['', ''];
        }

        const aLetters = aMatches[1];
        const aNumbers = parseInt(aMatches[2]);
      
        const bLetters = bMatches[1];
        const bNumbers = parseInt(bMatches[2]);
      
        // First, compare the letters
        if (aLetters < bLetters) {
          return -1;
        } else if (aLetters > bLetters) {
          return 1;
        } else {
          // If the letters are the same, compare the numbers
          return aNumbers - bNumbers;
        }
      }

    checked: boolean = false;
    public checkedMultiple: boolean = false;
    updateCheckStatus() {
        let colNum = this.listData.length;
        for (var i = 0; i < colNum; i++) {
            this.listData[i].selected = this.checkedAll;
        }
        this.checked = this.checkedAll;
        this.checkedMultiple = this.checkedAll;
    }
    checkAll() {
        this.updateCheckStatus();
        this.selectChange.emit({ type: 'selectChange'});
    }

    checkIfAllChecked() {
        this.checked = false;
        this.checkedMultiple = false;
        this.checkedAll = true;
        let colNum = this.listData.length;
        let countCheck = 0;
        for (var i = 0; i < colNum; i++) {
            if (this.listData[i].selected) {
                this.checked = true;
                countCheck++;
            } else {
                this.checkedAll = false;
            }
        }
        if (countCheck > 1) {
          this.checkedMultiple = true;
        }
      this.selectChange.emit({ type: 'selectChange'});
    }

    onPageChanged($event: PageEvent) {
        let clearCheckStatus = false;
        const oldCurrentPage = this.currentPage;
        const newCurrentPage = $event.pageIndex;
        if (oldCurrentPage != newCurrentPage) {
            this.currentPage = newCurrentPage;
            clearCheckStatus = true;
        }

        const oldItemCountPerPage = this.itemCountPerPage;
        const newItemCountPerPage = $event.pageSize;
        if (oldItemCountPerPage != newItemCountPerPage) {
            this.itemCountPerPage = newItemCountPerPage;
            clearCheckStatus = true;
        }

        if (clearCheckStatus) {
            this.checkedAll = false;
            this.updateCheckStatus();
        }
        this.pageChange.emit({
            type: 'pageChange',
            oldCurrentPage: oldCurrentPage,
            currentPage: newCurrentPage,
            oldItemCountPerPage: oldItemCountPerPage,
            itemCountPerPage: newItemCountPerPage
        });
    }

    goToPage($event: Event) {
        let newCurrentPageStr = ($event.target as HTMLInputElement).value;
        let newCurrentPage = parseInt(newCurrentPageStr);
        if (isNaN(newCurrentPage)) {
            return;
        }

        --newCurrentPage;
        if (newCurrentPage < 0) {
            newCurrentPage = 0;
        } else {
            const maxPage = this.maxPage;
            if (newCurrentPage > maxPage) {
                newCurrentPage = maxPage;
            }
        }

        const oldCurrentPage = this.currentPage;
        if (oldCurrentPage != newCurrentPage) {
            this.currentPage = newCurrentPage;
            this.checkedAll = false;
            this.updateCheckStatus();
            const itemCountPerPage = this.itemCountPerPage;
            this.pageChange.emit({
                type: 'pageChange',
                oldCurrentPage: oldCurrentPage,
                currentPage: newCurrentPage,
                oldItemCountPerPage: itemCountPerPage,
                itemCountPerPage: itemCountPerPage
            });
        }
    }

    updateMaxPage() {
        this.maxPage = Math.floor(this.itemCountTotal / this.itemCountPerPage);
    }
}



// WEBPACK FOOTER //
// ./src/app/common/component/tablelist/tablelist.component.ts